module.exports = __webpack_public_path__ + "img/bg_course_list_01.b6e1c2dc.png";